// common/services/b2b.api.ts
import { IVehicle } from "@/types/vehicle.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { IContractB2B, IVehicleB2BDetails } from "@/types/contractB2B.type";


const API_URL = `${import.meta.env.VITE_API_URL}/contract-b2b`;
const makeRequestDebounced = createDebounce(makeRequest, 200);
export interface ContractB2BPlatesResponse {
  licensePlates: string[];
}


export async function getActiveContractB2BPlates(
  idCompanyB2B: string
): Promise<ApiResponseType<ContractB2BPlatesResponse>> {
  if (!idCompanyB2B) {
    return {
      ok: false,
      message: "ID da Empresa B2B é obrigatório",
    } as ApiResponseType<ContractB2BPlatesResponse>;
  }
  const url = `${API_URL}/active-plates?idCompanyB2B=${idCompanyB2B}`;
  try {
    const result = (await makeRequest(
      url
    )) as ApiResponseType<ContractB2BPlatesResponse>;
    return result;
  } catch (error) {
    console.error("Falha ao buscar placas de contratos B2B:", error);
    return {
      ok: false,
      message: "Erro de rede ao buscar placas",
    } as ApiResponseType<ContractB2BPlatesResponse>;
  }
}

export async function getContractsB2B(
  idCompanyB2B: string,
  {
    page = 1,
    itemsPerPage = 10,
    orderBy = "-vencimento",
    search = "",
    fields = "_id, valor, vencimento, active, vehicles, createdAt",
  }: {
    page?: number;
    itemsPerPage?: number;
    orderBy?: string;
    search?: string;
    fields?: string;
  } = {}
) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    orderBy,
    fields,
  });

  if (search) {
    params.append("search", search);
  }

  // Filtra pelo ID da empresa
  params.append("filters[idCompanyB2B]", idCompanyB2B);

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IContractB2B[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function getAvailableVehicles(companyId: string) {
  const params = new URLSearchParams({
    "filters[companyId]": companyId,
    "filters[status]": "available",
    fields: "_id, licensePlate, brand, model",
    itemsPerPage: "999",
  });

  const url = `${API_URL}/vehicles/available-by-plates?${params.toString()}`;
  const result = (await makeRequest(url)) as ApiResponseType<IVehicle[]>;

  return { ok: result.ok, data: result.data };
}

export async function getB2BVehiclesConsolidated(idCompanyB2B: string) {
  const url = `${API_URL}/${idCompanyB2B}/vehicles-associated`;

  const result = (await makeRequest(url)) as ApiResponseType<
    IVehicleB2BDetails[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function updateContractB2B(
  id: string,
  contractData: Partial<IContractB2B>
) {
  const url = `${API_URL}/${id}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(contractData),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IContractB2B>
  >;
}

export async function createContractB2B(contractData: Partial<IContractB2B>) {
  const url = `${API_URL}/`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(contractData),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IContractB2B>
  >;
}




